import React, { useState } from 'react';
import {DetailProspectionTraitement} from "./DetailProspectionTraitement";
import {DetailProspectionResultat} from "./DetailProspectionResultat";
import {DetailProspectionProspection} from "./DetailProspectionProspection";

export const DetailProspectionTab = ({commune, openDownloadModal}) => {
    // On initialise l'onglet actif sur "prospection" comme dans ton HTML de base
    const [activeTab, setActiveTab] = useState('prospection');

    return (
        <div className="container py-4">
            <ul className="nav nav-tabs border-0 justify-content-center gap-3 gap-sm-3 gap-md-5 mb-3 mb-sm-4 mb-md-5" id="communeTab" role="tablist">

                <li className="nav-item" role="presentation">
                    <button
                        className={`nav-link fs-4 text-uppercase fw-sb border-0 bg-transparent px-0 pb-2 custom-tab-btn ${activeTab === 'traitement' ? 'active' : ''}`}
                        id="traitement-tab"
                        type="button"
                        role="tab"
                        aria-controls="traitement"
                        aria-selected={activeTab === 'traitement'}
                        onClick={() => setActiveTab('traitement')}
                    >
                        Traitement
                    </button>
                </li>

                <li className="nav-item" role="presentation">
                    <button
                        className={`nav-link fs-4 text-uppercase fw-sb border-0 bg-transparent px-0 pb-2 custom-tab-btn ${activeTab === 'prospection' ? 'active' : ''}`}
                        id="prospection-tab"
                        type="button"
                        role="tab"
                        aria-controls="prospection"
                        aria-selected={activeTab === 'prospection'}
                        onClick={() => setActiveTab('prospection')}
                    >
                        Prospection
                    </button>
                </li>

                {/* Onglet : Résultats */}
                <li className="nav-item" role="presentation">
                    <button
                        className={`nav-link fs-4 text-uppercase fw-sb border-0 bg-transparent px-0 pb-2 custom-tab-btn ${activeTab === 'analyses' ? 'active' : ''}`}
                        id="analyses-tab"
                        type="button"
                        role="tab"
                        aria-controls="analyses"
                        aria-selected={activeTab === 'analyses'}
                        onClick={() => setActiveTab('analyses')}
                    >
                        Résultats<span className="d-none d-md-inline"> des</span> analyses
                    </button>
                </li>
            </ul>

            <div className="tab-content" id="communeTabContent">


                <div
                    className={`tab-pane fade ${activeTab === 'traitement' ? 'show active' : ''}`}
                    id="traitement"
                    role="tabpanel"
                    aria-labelledby="traitement-tab"
                >
                    <DetailProspectionTraitement />
                </div>

                <div
                    className={`tab-pane fade ${activeTab === 'prospection' ? 'show active' : ''}`}
                    id="prospection"
                    role="tabpanel"
                    aria-labelledby="prospection-tab"
                >
                    <DetailProspectionProspection commune={commune} />
                </div>

                <div
                    className={`tab-pane fade ${activeTab === 'analyses' ? 'show active' : ''}`}
                    id="analyses"
                    role="tabpanel"
                    aria-labelledby="analyses-tab"
                >
                    <DetailProspectionResultat openDownloadModal={openDownloadModal} />
                </div>

            </div>
        </div>
    );
};